export const RATIO_HEIGHT = 9;
export const RATIO_WIDTH = 16;
export const DEFAULT_RATIO = RATIO_WIDTH / RATIO_HEIGHT;
export const OVERLAY_GAP = 8; // Отступы между ячейками

export const HEIGHT_RANGES = [
    {
        min: Math.round(180 * 0.5),
        max: Math.round(180 * 1.3),
    },
    {
        min: Math.round(360 * 0.7),
        max: Math.round(360 * 1.3),
    },
    {
        min: Math.round(720 * 0.7),
        max: Infinity,
    },
] as const;
